export const loginActionTypes = {
  REGISTER_USER: 'REGISTER_USER',
  REGISTER_USER_FAIL: 'REGISTER_USER_FAIL',
  REGISTER_USER_LOAD: 'REGISTER_USER_LOAD',
  VERIFY_OTP: 'VERIFY_OTP',
  VERIFY_OTP_ERROR: 'VERIFY_OTP_ERROR',
  VERIFY_OTP_LOAD: 'VERIFY_OTP_LOAD',
  VERIFY_MOBILE_LOAD: 'VERIFY_MOBILE_LOAD',
  VERIFY_MOBILE_SUCCESS: 'VERIFY_SUCCESS',
  VERIFY_MOBILE_FAIL: 'VERIFY_MOBILE_FAIL',
  REGISTER_USER_MODAL_CLOSE: 'REGISTER_USER_MODAL_CLOSE',
  CHECK_FIRST_LOGIN: 'CHECK_FIRST_LOGIN',
  SHOW_LOGIN_MODAL: 'SHOW_LOGIN_MODAL',
  IS_LOGGING_IN: 'IS_LOGGING_IN',
  MAGIC_LINK_AUTH_LOADING: 'MAGIC_LINK_AUTH_LOADING',
};
